<template>
  <div style="display:inline-block;position:relative;width:100%">
    <a-upload
      :accept="accept || '*'"
      :fileList="files"
      :remove="handleRemove"
      :beforeUpload="beforeUpload"
      :multiple="true"
      class="pipe-upload"
    >
      <a-button> <a-icon type="upload" />上传文件 </a-button>
      <p class="info" v-if="extra" style="margin: 10px 0 0">{{ extra }}</p>
    </a-upload>
    <span
      class="warring-color duplicate-info"
      :style="{ opacity: duplicateOpacity }"
    >
      <a-icon type="exclamation-circle" theme="filled"></a-icon>
      已过滤同名文件
    </span>
  </div>
</template>
<script>
export default {
  props: {
    accept: String,
    fileList: Array,
    defaultList: Array,
    extra: String,
  },
  data() {
    return {
      files: this.fileList,
      duplicate: false,
      duplicateOpacity: 0,
      timer: null,
    }
  },
  watch: {
    duplicate(newValue) {
      let timer = null
      if (newValue) {
        if (timer) {
          clearTimeout(timer)
        }
        this.duplicateOpacity = 1
        timer = setTimeout(() => {
          this.duplicateOpacity = 0
        }, 2000)
      }
    },
  },
  methods: {
    handleRemove(file) {
      const index = this.files.indexOf(file)
      const newFileList = this.files.slice()
      newFileList.splice(index, 1)
      this.files = newFileList
      this.$emit('onChange', this.files)
    },
    beforeUpload(file) {
      const fileNames = this.files.map(item => item.name)
      const names = this.defaultList
        ? [...this.defaultList, ...fileNames]
        : fileNames

      if (names.includes(file.name)) {
        this.duplicate = true
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.duplicate = false
        }, 2000)
      } else {
        this.files.push(file)
        this.$emit('onChange', this.files)
      }

      return false
    },
    clear() {
      this.files = []
      this.$emit('onChange', [])
    },
  },
}
</script>
<style lang="less" scoped>
.pipe-upload {
  :global {
    & /deep/ .ant-form-item {
      margin-bottom: 20px;
    }
  }
}
.duplicate-info {
  position: absolute;
  top: 0;
  left: 126px;
  transition: opacity 0.3s ease-in;
}
.hasExtra {
  margin-bottom: 14px;
}
</style>
